import styled from '@emotion/styled';
import { breakpoints, spacing, borderRadius } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';

export const VehicleInspectionWrapper = styled.div``;

export const VehicleInspectionContent = styled.div`
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(300px, 1fr);
  gap: ${spacing.space32};
  align-items: stretch;
  margin-bottom: ${spacing.space32};
  width: 100%;
  max-width: 100%;

  @media (max-width: ${breakpoints.m}) {
    grid-template-columns: 1fr;
    gap: ${spacing.space24};
  }
`;

export const AppBannerGridCol = styled.div`
  grid-column: 2 / -2;

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;

export const PvcTest = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${spacing.space32};
  border-radius: ${borderRadius.L};
  border: 1px solid ${nafColor.neutral.neutral2};
  min-width: 0;
`;

export const InfoTextWrapper = styled.div`
  margin-bottom: ${spacing.space40};
`;

export const StyledButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    marginTop: theme.spacing(5),
  },
}));
